import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Grid,
  Box,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

import TopButton from "../../../Components/UI/TopButtons";
import { makeStyles } from "@material-ui/core/styles";
import { getLearnerUsage } from "../Services";
import { joinByKeys } from "../../../Js/Common";
import { getFormatedDate } from "../../../Js/TimeAndDate";
import { commonSliceActions } from "../../../Store/Slices/CommonSlice";

const LearnerDetail = (props) => {
  const styles = useStyles();
  const dispatch = useDispatch();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { siteConfig } = useSelector((state) => state.defs);

  //State
  const [learnerUsage, setLearnerUsage] = useState([]);

  // React logic hooks
  useEffect(() => {
    const initialRender = async () => {
      dispatch(commonSliceActions.setLoader(true));
      await fetchLearnerUsageData();
    };
    initialRender();
  }, []);

  const fetchLearnerUsageData = async () => {
    let params = {
      query: {
        assignmentIds: props.reportData.assignment_ids,
        actor: props.reportData.uid,
        site_uuid: userInfo.site_uuid,
      },
    };
    let resLearnerUsage = await getLearnerUsage(params);
    // console.log("===>resLearnerUsage",resLearnerUsage);
    // return false;
    dispatch(commonSliceActions.setLoader(false));
    setLearnerUsage(resLearnerUsage);
    return;
  };

  const handleDownload = async () => {
    if (learnerUsage.data.length > 0) {
      let csv = "";
      csv = "Assignment, Total Assets, Attempted, Ratio(%), Usage [HH:MM:SS]\n";
      learnerUsage.data.forEach((element) => {
        let name = element.title.replace(/;/g, "").replace(/,/g, "");
        let totalAssets = element.totalassets ? element.totalassets : 0;
        let totalAttemptedAssets = element.attemptedassets
          ? element.attemptedassets
          : 0;
        let totalPerAttemptedAssets =
          ((totalAttemptedAssets / totalAssets) * 100).toFixed(2) + "%";
        let usages = element.usages ? element.usages : "00:00";

        csv =
          csv +
          name +
          "," +
          totalAssets +
          "," +
          totalAttemptedAssets +
          "," +
          totalPerAttemptedAssets +
          "," +
          usages;
        csv += "\n";
      });

      let startDate = getFormatedDate(props.startOfDate, "DD-MMM-YY");
      let endDate = getFormatedDate(props.endOfMonth, "DD-MMM-YY");

      let fileStudentName =
        joinByKeys(props.reportData.name, ["firstname", "lastname"], "_") +
        "_Usage_Report";
      let fileName =
        fileStudentName + "_" + startDate + "_to_" + endDate + "_" + ".csv";

      let hiddenElement = document.createElement("a");
      hiddenElement.setAttribute(
        "href",
        "data:text/csv;charset=utf-8," + encodeURIComponent(csv)
      );

      hiddenElement.setAttribute("download", fileName);
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
      document.body.removeChild(hiddenElement);
    }
  };
  const handleClose = () => {
    localStorage.setItem("strtDate", props.startOfDate);
    localStorage.setItem("endDate", props.endOfMonth);
    localStorage.setItem("classId", JSON.stringify(props.selectedClassId));
    props.backList(true);
  };

  return (
    <>
      <TopButton
        title={
          "Usage Report | " +
          joinByKeys(props.reportData.name, ["firstname", "lastname"], " ") +
          " (" +
          props.selectedClass +
          ")"
        }
        secondaryText={
          getFormatedDate(props.startOfDate, "DD MMM YYYY") +
          " - " +
          getFormatedDate(props.endOfMonth, "DD MMM YYYY")
        }
        downloadIcon={true}
        pressTopBtn={handleDownload}
        closeIcon={true}
        pressCloseBtn={handleClose}
      />
      <Box sx={{}}>
        <Grid container sx={{ px: 10 }}>
          <Grid item xs={12}>
            <Table sx={{ minWidth: 400 }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    align="justify"
                    sx={{
                      width: "40%",
                      color: "#DB8829",
                      fontSize: "1rem",
                      fontWeight: "700",
                      padding: "1px",
                      py: 1.5,
                      "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                    }}
                  >
                    Assignment
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      width: "10%",
                      color: "#DB8829",
                      fontSize: "1rem",
                      fontWeight: "700",
                      padding: "1px",
                      py: 1.5,
                      "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                    }}
                  >
                    Assets
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      width: "10%",
                      color: "#DB8829",
                      fontSize: "1rem",
                      fontWeight: "700",
                      padding: "1px",
                      py: 1.5,
                      "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                    }}
                  >
                    Attempted
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      width: "10%",
                      color: "#DB8829",
                      fontSize: "1rem",
                      fontWeight: "700",
                      padding: "1px",
                      py: 1.5,
                      "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                    }}
                  >
                    Ratio(%)
                  </TableCell>
                  {!siteConfig?.customer?.addOnInfo?.isEstimatedDuration && (
                    <TableCell
                      align="center"
                      sx={{
                        width: "30%",
                        color: "#DB8829",
                        fontSize: "1rem",
                        fontWeight: "700",
                        padding: "1px",
                        py: 1.5,
                        "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                      }}
                    >
                      Usage (HH:MM:SS)
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
            </Table>
            {/* {JSON.stringify(learnerUsage.data[0])} */}
            <div
              style={{ height: "70vh", overflow: "auto" }}
              className={styles.scrollBar}
            >
              {learnerUsage && learnerUsage.data && (
                <Table style={{ tableLayout: "fixed" }}>
                  <TableBody>
                    {learnerUsage.data.map((learnerData, learnerIndex) => {
                      return (
                        <TableRow
                          key={`learnerUsage_${learnerIndex}`}
                          sx={{ py: 0 }}
                        >
                          <TableCell
                            sx={{
                              width: "40%",
                              wordBreak: "break-all",
                              color: "#DB8829",
                              fontSize: "0.8rem",
                              fontWeight: "600",
                              padding: "10px",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.2rem",
                              },
                            }}
                          >
                            {learnerData.title}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              width: "10%",
                              color: "#DB8829",
                              fontSize: "0.8rem",
                              fontWeight: "500",
                              padding: "10px",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.2rem",
                              },
                            }}
                          >
                            {learnerData.totalassets || 0}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              width: "10%",
                              color: "#DB8829",
                              fontSize: "0.8rem",
                              fontWeight: "500",
                              padding: "10px",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.2rem",
                              },
                            }}
                          >
                            {learnerData.attemptedassets || 0}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              width: "10%",
                              color: "#DB8829",
                              fontSize: "0.8rem",
                              fontWeight: "500",
                              padding: "10px",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.2rem",
                              },
                            }}
                          >
                            {(
                              (learnerData.attemptedassets /
                                learnerData.totalassets) *
                              100
                            ).toFixed(2) + "%"}
                          </TableCell>
                          {!siteConfig?.customer?.addOnInfo
                            ?.isEstimatedDuration && (
                            <TableCell
                              align="center"
                              sx={{
                                width: "30%",
                                color: "#DB8829",
                                fontSize: "0.8rem",
                                fontWeight: "500",
                                padding: "10px",
                                "@media (min-width: 1636px)": {
                                  fontSize: "1.2rem",
                                },
                              }}
                            >
                              {learnerData.usages || "00:00:00"}
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              )}
            </div>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default LearnerDetail;
